import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/core';
import { AxiosApi } from '@digibricks/plugin-axios';
import { ErrorResultHandler } from '@lib/domain-common';
export var FORM_RELEASE_API = 'FORM_RELEASE_API';
export var FormReleaseApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(FormReleaseApi, _AxiosApi);

  var _super = _createSuper(FormReleaseApi);

  function FormReleaseApi(axiosInstance, formReleaseApiMapper) {
    var _this;

    _classCallCheck(this, FormReleaseApi);

    _this = _super.call(this, 'form-releases', axiosInstance);
    _this.axiosInstance = axiosInstance;
    _this.formReleaseApiMapper = formReleaseApiMapper;
    return _this;
  }

  _createClass(FormReleaseApi, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.axios.post(this.url, input);

              case 3:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;
                return _context.abrupt("return", Result.ok(parsedResponseBody.data));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "findFormReleaseById",
    value: function () {
      var _findFormReleaseById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                url = "".concat(this.url, "/").concat(id);
                _context2.next = 4;
                return this.axios.get(url, {
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  }
                });

              case 4:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;
                return _context2.abrupt("return", Result.ok(this.formReleaseApiMapper.toDomain(parsedResponseBody.data)));

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function findFormReleaseById(_x2) {
        return _findFormReleaseById.apply(this, arguments);
      }

      return findFormReleaseById;
    }()
  }, {
    key: "findLatestByFormId",
    value: function () {
      var _findLatestByFormId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(formId) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                url = "".concat(this.url, "/latest");
                _context3.next = 4;
                return this.axios.get(url, {
                  params: {
                    formId: formId
                  },
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  }
                });

              case 4:
                jsonResponse = _context3.sent;
                parsedResponseBody = jsonResponse.data;
                return _context3.abrupt("return", Result.ok(parsedResponseBody.data));

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 9]]);
      }));

      function findLatestByFormId(_x3) {
        return _findLatestByFormId.apply(this, arguments);
      }

      return findLatestByFormId;
    }()
  }]);

  return FormReleaseApi;
}(AxiosApi);